import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=899b92cc&scoped=true"
import script from "./RootNode.vue?vue&type=script&lang=js"
export * from "./RootNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b92cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('899b92cc')) {
      api.createRecord('899b92cc', component.options)
    } else {
      api.reload('899b92cc', component.options)
    }
    module.hot.accept("./RootNode.vue?vue&type=template&id=899b92cc&scoped=true", function () {
      api.rerender('899b92cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/RootNode.vue"
export default component.exports